module.exports = __webpack_public_path__ + "static/media/background.ce7703aa.png";